import type { CSSObject } from '@emotion/react';

import type {
  ThemeType,
} from '@n3/css-base';

export const createPlaceholderStyle = ({
  colors,
  fonts,
  input,
}: ThemeType) => (): CSSObject => ({
  ...fonts.DEFAULT,
  marginLeft: 2,
  marginRight: 2,
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  boxSizing: 'border-box',
  color: colors[input.PLACEHOLDER_COLOR],
  whiteSpace: 'nowrap',
});
